"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDialogFooterCtx = exports.DialogFooter = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var rc_dialog_1 = tslib_1.__importDefault(require("rc-dialog"));
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
var icons_1 = require("../icons");
var Mask_1 = tslib_1.__importDefault(require("../internal/Mask"));
var hooks_1 = require("../Modal/hooks");
var PopupContainerProvider_1 = require("../PopupContainerProvider");
var Footer_1 = require("../Modal/Footer");
Object.defineProperty(exports, "DialogFooter", { enumerable: true, get: function () { return tslib_1.__importDefault(Footer_1).default; } });
Object.defineProperty(exports, "useDialogFooterCtx", { enumerable: true, get: function () { return Footer_1.useFooterCtx; } });
tslib_1.__exportStar(require("./status-dialog"), exports);
function Dialog(props) {
    var icon = props.icon, title = props.title, children = props.children, modalProps = tslib_1.__rest(props, ["icon", "title", "children"]);
    var prefix = ConfigProvider_1.usePrefix('dialog');
    var _a = hooks_1.useModalProps(tslib_1.__assign(tslib_1.__assign({}, modalProps), { children: undefined, title: undefined }), prefix), maskProps = _a.maskProps, _b = _a.rcDialogProps, footer = _b.footer, rcDialogProps = tslib_1.__rest(_b, ["footer"]);
    var iconPrefix = utils_1.concat(prefix, 'body-icon');
    var mainPrefix = utils_1.concat(prefix, 'body-main');
    var titlePrefix = utils_1.concat(mainPrefix, 'title');
    var contentPrefix = utils_1.concat(mainPrefix, 'content');
    var footerPrefix = utils_1.concat(mainPrefix, 'footer');
    var popupContainerRef = react_1.useRef(null);
    var titleIcon = icon === true ? react_1.default.createElement(icons_1.TipIcon, null) : icon;
    return (react_1.default.createElement(Mask_1.default, tslib_1.__assign({}, maskProps),
        react_1.default.createElement(rc_dialog_1.default, tslib_1.__assign({}, rcDialogProps),
            titleIcon && react_1.default.createElement("div", { className: iconPrefix }, titleIcon),
            react_1.default.createElement("div", { className: mainPrefix },
                title && react_1.default.createElement("div", { className: titlePrefix }, title),
                react_1.default.createElement("div", { className: contentPrefix, ref: popupContainerRef },
                    react_1.default.createElement(PopupContainerProvider_1.PopupContainerProvider, { containerRef: popupContainerRef }, children)),
                react_1.default.createElement("div", { className: footerPrefix }, footer)))));
}
exports.default = Dialog;
//# sourceMappingURL=index.js.map